import { useDispatch, useSelector } from 'react-redux';
import { toggleFavorite } from '../ducks/favorites.duck';
import useTopbarAuthModal from './useTopbarAuthModal';

/**
 * Custom hook for toggling favorites on listings
 * @param {string} listingId - The UUID of the listing
 * @returns {Object} - { onFavoriteClick, isFavorited, isToggling }
 */
const useFavoriteToggle = (listingId) => {
  const dispatch = useDispatch();
  const openTopbarAuthModal = useTopbarAuthModal();

  const currentUser = useSelector(state => state.user.currentUser);
  const inProgressById = useSelector(state => state.favorites?.inProgressById || {});

  const favorites = currentUser?.attributes?.profile?.privateData?.favorites || [];
  const isFavorited = Array.isArray(favorites) && favorites.includes(listingId);
  const isToggling = !!inProgressById[listingId];

  const onFavoriteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!currentUser) {
      openTopbarAuthModal('login');
      return;
    }

    if (isToggling) return;
    dispatch(toggleFavorite(listingId));
  };

  return {
    onFavoriteClick,
    isFavorited,
    isToggling,
  };
};

export default useFavoriteToggle;

